if (!customElements.get('tiered-product-bundle')) {
  class TieredProductBundle extends HTMLElement {
    connectedCallback() {
      if (this.initialised) return;
      this.initialised = true;
      this.config = JSON.parse(this.querySelector('[data-bundle-config]').textContent);
      this.selected = new Map();
this.defaultCategoryImages = new Map();
this.defaultCategoryTitles = new Map();

this.querySelectorAll('[data-category]').forEach((row) => {
  const imageContainer = row.querySelector('[data-category-image]');

  this.defaultCategoryImages.set(
    row.dataset.category,
    imageContainer ? imageContainer.innerHTML : ''
  );

  this.defaultCategoryTitles.set(
    row.dataset.category,
    row.dataset.categoryTitleValue || 'Products'
  );
});

this.dialog = this.querySelector('[data-bundle-dialog]');
      this.addButton = this.querySelector('[data-add-bundle]');
      this.message = this.querySelector('[data-bundle-message]');
      this.bindEvents();
      this.updateTotal();
    }

    bindEvents() {
      this.addEventListener('click', (event) => {
        const open = event.target.closest('[data-open-category]');
const remove = event.target.closest('[data-remove-category]');
const select = event.target.closest('[data-select-product]');
const review = event.target.closest('[data-review-bundle]');
const removeSelected = event.target.closest(
  '[data-remove-selected-product]'
);

if (open) this.openCategory(open.dataset.openCategory);
if (remove) this.removeCategory(remove.dataset.removeCategory);
if (select) this.selectProduct(select);
if (review) this.dialog.close();

if (removeSelected) {
  this.removeSelectedProduct(removeSelected);
}
      });
      this.querySelector('[data-close-dialog]')?.addEventListener('click', () => this.dialog.close());
      this.dialog?.addEventListener('click', (event) => {
  if (event.target === this.dialog) {
    this.dialog.close();
  }
});

this.dialog?.addEventListener('close', () => {
  document.documentElement.classList.remove('bundle-dialog-open');
});
      this.querySelectorAll('[data-card-variant]').forEach((select) => {
        select.addEventListener('change', () => {
  const option = select.selectedOptions[0];
  const card = select.closest('.bundle-builder__card');
  const image = card.querySelector('.bundle-builder__card-image img');

  const currentPrice = card.querySelector('[data-card-current-price]');
const comparePrice = card.querySelector('[data-card-compare-price]');
const priceValue = Number(option.dataset.price) || 0;
const comparePriceValue = Number(option.dataset.compareAtPrice) || 0;
const isSaleVariant = comparePriceValue > priceValue;

if (currentPrice) {
  currentPrice.textContent = option.dataset.priceFormatted;
}

if (comparePrice) {
  comparePrice.textContent =
    option.dataset.compareAtPriceFormatted || '';
  comparePrice.hidden = !isSaleVariant;
}

  if (image && option.dataset.image) {
  image.src = option.dataset.image;
  image.removeAttribute('srcset');
}

const addButton = card.querySelector('[data-select-product]');
const key = `${addButton.dataset.categoryIndex}:${addButton.dataset.productId}`;

if (this.selected.has(key)) {
  const item = this.selected.get(key);

  item.id = option.value;
item.price = Number(option.dataset.price);
item.compareAtPrice = Number(option.dataset.compareAtPrice) || 0;
item.variant = option.textContent.trim();
item.image = option.dataset.image;

  this.selected.set(key, item);
  this.renderCategory(addButton.dataset.categoryIndex);
  this.updateTotal();
}
});
      });
      this.querySelectorAll('[data-card-quantity]').forEach((input) => {
        input.addEventListener('input', () => this.updateItemQuantity(input));
        input.addEventListener('change', () => this.updateItemQuantity(input));
      });
      this.addButton?.addEventListener('click', () => this.addBundle());
    }

    openCategory(index) {
  let activeGrid = null;

  this.querySelectorAll('[data-product-grid]').forEach((grid) => {
    const isActive = grid.dataset.productGrid === index;
    grid.hidden = !isActive;

    if (isActive) {
      activeGrid = grid;
    }
  });

  const row = this.querySelector(`[data-category="${index}"]`);

  this.querySelector('[data-dialog-title]').textContent =
    `Choose ${row.dataset.categoryTitleValue || 'products'}`;

  this.dialog.dataset.productCount =
    activeGrid?.dataset.productCount || '1';

  document.documentElement.classList.add('bundle-dialog-open');
this.dialog.showModal();
}

    selectProduct(button) {
  const card = button.closest('.bundle-builder__card');
  const select = card.querySelector('[data-card-variant]');
  const option = select.selectedOptions[0];
  const category = button.dataset.categoryIndex;
  const productId = button.dataset.productId;
  const key = `${category}:${productId}`;

  if (this.selected.has(key)) return;

  const quantityInput = card.querySelector('[data-card-quantity]');
  const quantity = Math.max(1, Number(quantityInput?.value) || 1);

  this.selected.set(key, {
  id: option.value,
  productId,
  category,
  price: Number(option.dataset.price),
  compareAtPrice: Number(option.dataset.compareAtPrice) || 0,
  quantity,
  title: button.dataset.productTitle,
  variant: option.textContent.trim(),
  image: option.dataset.image
});

  card.classList.add('is-selected');

  button.classList.add('is-added');
  button.textContent = 'Added';
  button.setAttribute('aria-pressed', 'true');

  const removeButton = card.querySelector(
    '[data-remove-selected-product]'
  );

  if (removeButton) {
    removeButton.hidden = false;
  }

  this.renderCategory(category);
  this.updateReviewBar();
  this.updateTotal();
}

    updateItemQuantity(input) {
      const card = input.closest('.bundle-builder__card');
      const button = card?.querySelector('[data-select-product]');
      if (!button) return;

      const key = `${button.dataset.categoryIndex}:${button.dataset.productId}`;
      const quantity = Math.max(1, Number(input.value) || 1);
      input.value = quantity;

      if (!this.selected.has(key)) return;
      const item = this.selected.get(key);
      item.quantity = quantity;
      this.selected.set(key, item);
      this.renderCategory(item.category);
      this.updateReviewBar();
      this.updateTotal();
    }

    removeSelectedProduct(removeButton) {
  const category = removeButton.dataset.categoryIndex;
  const productId = removeButton.dataset.productId;
  const key = `${category}:${productId}`;
  const card = removeButton.closest('.bundle-builder__card');
  const addButton = card.querySelector('[data-select-product]');

  this.selected.delete(key);

  card.classList.remove('is-selected');
  removeButton.hidden = true;

  addButton.classList.remove('is-added');
  addButton.textContent = 'Add';
  addButton.setAttribute('aria-pressed', 'false');

  this.renderCategory(category);
  this.updateReviewBar();
  this.updateTotal();
}

removeCategory(index) {
  this.selected.forEach((item, key) => {
    if (item.category === index) {
      this.selected.delete(key);
    }
  });

  this.querySelectorAll(
    `[data-bundle-card][data-category-index="${index}"]`
  ).forEach((card) => {
    const addButton = card.querySelector('[data-select-product]');
    const removeButton = card.querySelector(
      '[data-remove-selected-product]'
    );

    card.classList.remove('is-selected');

    if (addButton) {
      addButton.classList.remove('is-added');
      addButton.textContent = 'Add';
      addButton.setAttribute('aria-pressed', 'false');
    }

    if (removeButton) {
      removeButton.hidden = true;
    }
  });

  this.renderCategory(index);
  this.updateReviewBar();
  this.updateTotal();
}

    renderCategory(index) {
  const row = this.querySelector(`[data-category="${index}"]`);
  if (!row) return;

  const items = [...this.selected.values()].filter(
    (item) => item.category === index
  );

  const openButton = row.querySelector('[data-open-category]');
  const removeButton = row.querySelector('[data-remove-category]');
  const imageContainer = row.querySelector('[data-category-image]');
  const summary = row.querySelector('[data-selection-summary]');
  const selectionTitle = row.querySelector('[data-selection-title]');
  const selectionStatus = row.querySelector('[data-selection-status]');
  const selectionPrice = row.querySelector('[data-category-price]');

  if (items.length === 0) {
    row.classList.remove(
      'has-selected-product',
      'has-multiple-products'
    );

    imageContainer.classList.remove(
      'has-selected-product',
      'has-selected-products'
    );

    imageContainer.innerHTML =
      this.defaultCategoryImages.get(String(index)) || '';

    if (summary) summary.hidden = true;

    if (selectionTitle) {
      selectionTitle.textContent = '';
    }

    if (selectionStatus) {
      selectionStatus.textContent = '';
    }

    if (selectionPrice) {
      selectionPrice.textContent = '';
    }

    openButton.hidden = false;
    openButton.textContent = '+';
    openButton.classList.remove('is-selected');
    openButton.setAttribute('aria-label', 'Choose products');

    removeButton.hidden = true;
    return;
  }

  const totalQuantity = items.reduce(
    (total, item) => total + item.quantity,
    0
  );

  const categoryTotal = items.reduce(
    (total, item) => total + item.price * item.quantity,
    0
  );

  if (summary) summary.hidden = false;

  if (selectionPrice) {
    selectionPrice.textContent = this.formatMoney(categoryTotal);
  }

  if (items.length === 1) {
    const item = items[0];

    row.classList.add('has-selected-product');
    row.classList.remove('has-multiple-products');

    imageContainer.classList.add('has-selected-product');
    imageContainer.classList.remove('has-selected-products');

    imageContainer.innerHTML = item.image
      ? `
        <img
          src="${item.image}"
          alt=""
          loading="lazy"
        >
      `
      : '';

    if (selectionTitle) {
      selectionTitle.textContent = item.title;
    }

    if (selectionStatus) {
      selectionStatus.textContent =
        item.quantity > 1
          ? `${item.variant} · Qty ${item.quantity}`
          : item.variant;
    }

    openButton.hidden = true;

    removeButton.hidden = false;
    removeButton.textContent = '×';
    removeButton.setAttribute(
      'aria-label',
      `Remove ${item.title}`
    );

    return;
  }

  row.classList.remove('has-selected-product');
  row.classList.add('has-multiple-products');

  imageContainer.classList.remove('has-selected-product');
  imageContainer.classList.add('has-selected-products');

  const imageItems = items
    .filter((item) => item.image)
    .slice(0, 3);

  imageContainer.innerHTML = imageItems
    .map(
      (item, position) => `
        <img
          src="${item.image}"
          alt=""
          loading="lazy"
          class="bundle-builder__stacked-image bundle-builder__stacked-image--${position + 1}"
        >
      `
    )
    .join('');

  if (selectionTitle) {
    selectionTitle.textContent =
      `${totalQuantity} Products Selected`;
  }

  if (selectionStatus) {
    selectionStatus.textContent = 'Review or update your selection';
  }

  openButton.hidden = false;
  openButton.textContent = '⋮';
  openButton.classList.add('is-selected');
  openButton.setAttribute(
    'aria-label',
    'Review selected products'
  );

  removeButton.hidden = true;
}

updateReviewBar() {
  const reviewBar = this.querySelector('[data-review-bar]');
  const reviewCount = this.querySelector('[data-review-count]');

  if (!reviewBar || !reviewCount) return;

  const selectedCount = [...this.selected.values()].reduce(
    (total, item) => total + item.quantity,
    0
  );

  reviewCount.textContent = selectedCount;
reviewBar.hidden = false;
reviewBar.classList.toggle('is-empty', selectedCount === 0);
}

updateTotal() {
  let total = 0;
  let eligibleTotal = 0;
  let excludedSaleTotal = 0;
  let eligibleQuantity = 0;

  const excludeSaleProducts =
    this.config.excludeSaleProducts === true;

  this.selected.forEach((item) => {
    const lineTotal = item.price * item.quantity;
    const compareAtPrice = Number(item.compareAtPrice) || 0;

    const isSaleProduct =
      excludeSaleProducts &&
      compareAtPrice > item.price;

    total += lineTotal;

    if (isSaleProduct) {
      excludedSaleTotal += lineTotal;
    } else {
      eligibleTotal += lineTotal;
      eligibleQuantity += item.quantity;
    }
  });

  const tierOneMinimum =
    Number(this.config.tierOneMinimum) || 2;

  const tierOnePercent =
    Number(this.config.tierOnePercent) || 5;

  const tierTwoMinimum =
    Number(this.config.tierTwoMinimum) || 4;

  const tierTwoPercent =
    Number(this.config.tierTwoPercent) || 10;

  let discountPercent = 0;

  if (eligibleQuantity >= tierTwoMinimum) {
    discountPercent = tierTwoPercent;
  } else if (eligibleQuantity >= tierOneMinimum) {
    discountPercent = tierOnePercent;
  }

  const discountedEligibleTotal = Math.round(
    eligibleTotal * (1 - discountPercent / 100)
  );

  const finalTotal =
    excludedSaleTotal + discountedEligibleTotal;

  const actualSaving = total - finalTotal;
  const hasBundleDiscount = actualSaving > 0;

  const finalPrice =
    this.querySelector('[data-bundle-total]');

  const originalPrice =
    this.querySelector('[data-bundle-original-total]');

  if (finalPrice) {
    finalPrice.textContent = this.formatMoney(finalTotal);
  }

  if (originalPrice) {
    originalPrice.textContent = this.formatMoney(total);
    originalPrice.hidden = !hasBundleDiscount;
  }

  const badge =
    this.querySelector('[data-bundle-discount-badge]');

  if (badge) {
    badge.textContent = hasBundleDiscount
      ? `Save ${discountPercent}%`
      : '';

    badge.hidden = !hasBundleDiscount;
  }

  const progress =
    this.querySelector('[data-bundle-progress]');

  if (progress) {
    if (this.selected.size === 0) {
      progress.textContent = this.config.labels.choose;
    } else if (eligibleQuantity === 0) {
      progress.textContent =
        'Sale items are already discounted';
    } else if (eligibleQuantity < tierOneMinimum) {
      const remaining =
        tierOneMinimum - eligibleQuantity;

      progress.textContent =
        `Add ${remaining} more eligible ${
          remaining === 1 ? 'item' : 'items'
        } to unlock ${tierOnePercent}% off`;
    } else if (eligibleQuantity < tierTwoMinimum) {
      const remaining =
        tierTwoMinimum - eligibleQuantity;

      progress.textContent =
        `${tierOnePercent}% off eligible full-price items. Add ${remaining} more eligible ${
          remaining === 1 ? 'item' : 'items'
        } to unlock ${tierTwoPercent}% off`;
    } else if (excludedSaleTotal > 0) {
      progress.textContent =
        `${tierTwoPercent}% off eligible full-price items`;
    } else {
      progress.textContent =
        `${tierTwoPercent}% bundle discount unlocked`;
    }
  }

  this.addButton.disabled = this.selected.size === 0;
}

formatMoney(cents) {
  return new Intl.NumberFormat(
    this.config.locale || 'en-GB',
    {
      style: 'currency',
      currency: this.config.currency || 'GBP'
    }
  ).format(cents / 100);
}

async addBundle() {
  if (
    this.selected.size === 0 ||
    this.classList.contains('is-loading')
  ) return;

  const items = [...this.selected.values()].map((item) => ({
    id: Number(item.id),
    quantity: item.quantity
  }));

  const root = window.Shopify?.routes?.root || '/';

  const sectionIds = [...new Set(
    Array.from(document.querySelectorAll('cart-items-component'))
      .map((component) => component.dataset.sectionId)
      .filter(Boolean)
  )];

  this.classList.add('is-loading');
  this.addButton.disabled = true;
  this.message.hidden = true;

  let added = false;

  try {
    const payload = {
      items,
      sections_url: window.location.pathname
    };

    if (sectionIds.length) {
      payload.sections = sectionIds.join(',');
    }

    const response = await fetch(`${root}cart/add.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify(payload)
    });

    const result = await response.json();

    if (!response.ok || result.status) {
      throw new Error(result.description || 'Unable to add products.');
    }

    added = true;

    const cartResponse = await fetch(`${root}cart.js`, {
      headers: { Accept: 'application/json' }
    });

    if (!cartResponse.ok) {
      throw new Error('Unable to refresh the basket.');
    }

    const cart = await cartResponse.json();

    document.dispatchEvent(new CustomEvent('cart:update', {
      bubbles: true,
      detail: {
        resource: cart,
        sourceId: this.id || 'bundle-builder',
        data: {
          source: 'bundle-builder',
          itemCount: items.reduce(
            (total, item) => total + item.quantity,
            0
          ),
          sections: result.sections || {}
        }
      }
    }));

    document.querySelector('cart-drawer-component[auto-open]')?.open();

    this.message.textContent = this.config.labels.added;
    this.message.hidden = false;
  } catch (error) {
    this.message.textContent = added
      ? 'Products were added. Please open your basket to check them before adding again.'
      : error.message || this.config.labels.error;

    this.message.hidden = false;
  } finally {
    this.classList.remove('is-loading');
    this.addButton.disabled = this.selected.size === 0;
  }
}
  }
  customElements.define('tiered-product-bundle', TieredProductBundle);
}
